module.exports = __webpack_public_path__ + "img/classy-white.4e5c20bb.svg";